import MarkdownIt from "markdown-it";
import markdownItContainer from "markdown-it-container";

export class MarkDownTokenParser {
  constructor(data) {
    this.containers = getContainerNames(data);
    this.data = fetchTokens(data, this.containers)
      .then((tokens) => this.divideIntoContainers(tokens))
      .then((dataObj) => this.createHtml(dataObj));

    // Define the title and content element IDs in the derived constructors
    // this.titleElementId;
    // this.contentElementId;
    // this.containerIds = {};
    // this.containerData = {};
    // this.containers = getContainers(data);
    // this.tokens = fetchTokens(data, this.containers);
    // this.containerContent = {};
    // this.contentElements = [];
  }

  async divideIntoContainers(tokens) {
    const containersStartIndexes = tokens.reduce((acc, token, index) => {
      if (token.type.includes("container") && token.type.includes("open")) {
        acc.push(index);
      }
      return acc;
    }, []);
    const containerEndIndexes = tokens.reduce((acc, token, index) => {
      if (token.type.includes("container") && token.type.includes("close")) {
        acc.push(index);
      }
      return acc;
    }, []);

    const result = {};
    containersStartIndexes.forEach((startIndex, idx) => {
      const containerName = tokens[startIndex].info.trim();
      const containerLength = containerEndIndexes[idx] - startIndex;
      // console.log(
      //   `Processing container ${containerName} with a length of ${containerLength}:`
      // );
      const containerTokens = tokens.slice(
        startIndex + 1,
        containerEndIndexes[idx]
      );
      // console.log(containerTokens);
      result[containerName] = containerTokens;
    });
    return result;
  }

  async createHtml(dataobj) {
    const md = new MarkdownIt(); // no need to add plugins here; we’re rendering tokens
    const result = {};
    for (const [key, containerTokens] of Object.entries(dataobj)) {
      result[key] = md.renderer.render(containerTokens, md.options, {}); // ← this is the trick
    }
    return result;
  }

  async render() {
    const resultObj = await this.data;
    const keys = Object.keys(resultObj);
    keys.forEach((key) => {
      // console.log(`Rendering ${key}`);

      const currElement = document.querySelector(`#${key}`);
      if (
        key.includes("button") ||
        key.includes("title") ||
        key.includes("footer") ||
        key.includes("link")
      ) {
        // console.log(`Setting ${key} to value ${resultObj[key]}`);
        currElement.innerHTML = resultObj[key]
          .trim()
          .replace(/^<p>|<\/p>$/g, "");
      } else {
        currElement.innerHTML = resultObj[key];
      }
      currElement.classList.remove("placeholder", "placeholder-wave");
    });
  }
}

// ---------------- MAIN FUNCTION ----------------
// processAll(tokens) {
//   this.containerData = this.processContainers(containerTokens);
// }

// ---------------- MAIN CONTENT PARSER ----------------

// async processContentTokens(tokens) {
//   const contentArray = [];
//   let currentElement;
//   tokens.forEach((token) => {
//     //   console.log(token, token.type, token.content);
//     if (token.type.includes("open")) {
//       currentElement = token.tag.trim();
//     }
//     if (token.type === "inline") {
//       const cleanedContent = token.content.replace(/\n/g, " ");
//       contentArray.push({
//         tagType: currentElement,
//         content: cleanedContent,
//       });
//     }
//   });
//   // console.log(contentArray);
//   return contentArray;
// }

// -------- GET INDEXES OF THE CONTAINERS --------

// getContainerIndexes(tokens) {
//   const containersStartIndex = tokens.reduce((acc, token, idx) => {
//     //console.log(token.type, typeof token.type);
//     if (token.type.includes("container") && token.type.includes("open")) {
//       if (acc === undefined) {
//         // console.log(token, idx);
//         return idx;
//       } else return acc;
//     }
//     return acc;
//   }, undefined);
//   const containersEndIndex = tokens.reduce((acc, token, idx) => {
//     if (token.type.includes("container") && token.type.includes("close")) {
//       return idx;
//     } else return acc;
//   }, undefined);
//   //console.log(containersStartIndex, containersEndIndex);
//   return { containersStartIndex, containersEndIndex }; //containersStartIndex, containersEndIndex;
// }

// ----- GET THE DATA FROM THE CONTAINERS ----

// processContainers(tokens) {
//   const resultObj = {};
//   let currContainer;

//   tokens.forEach((token) => {
//     // console.log(token, token.type, token.content);
//     if (token.type.includes("container") && token.type.includes("open")) {
//       currContainer = token.info.trim();
//     }
//     if (token.type === "inline") {
//       resultObj[currContainer] = token.content;
//     }
//   });
//   return resultObj;
// }

// ---------------- RENDER ----------------
// render() {
//   const titleElement = document.querySelector(`#${this.titleElementId}`);
//   const containerKeys = Object.keys(this.containerData);
//   // Flatten the object
//   const elementAcc = {};
//   if (this.containerIds) {
//     Object.keys(this.containerIds).forEach((containerType) => {
//       Object.keys(this.containerIds[containerType]).forEach((containerId) => {
//         elementAcc[containerId] =
//           this.containerIds[containerType][containerId];
//       });
//     });
//     if (containerKeys.length > 0) {
//       containerKeys.forEach((containerId) => {
//         const currElement = document.querySelector(
//           `#${elementAcc[containerId]}`
//         );
//         currElement.innerHTML = this.containerData[containerId];
//       });
//     }
//   }
//   // console.log(this.tokens);
//   if (this.contentElements && this.titleElementId) {
//     titleElement.innerHTML = this.contentElements[0].content;
//   }
//   const textContent = this.contentElements.slice(1).reduce((acc, el) => {
//     const line =
//       "<" + el.tagType + ">" + el.content + "</" + el.tagType + ">";
//     return acc + line;
//   }, "");
//   if (this.contentElementId) {
//     const contentElement = document.querySelector(
//       `#${this.contentElementId}`
//     );
//     contentElement.innerHTML = textContent;
//   }
// }

/**
 * Fetches the markdown tokens from a given filename. The function takes a filename and an array of button classes as parameters.
 * It uses the markdown-it library to parse the markdown content and returns the parsed tokens.
 * @param {string} filename - The filename of the markdown file to parse
 * @param {Array<string>} buttonArray - An array of button classes to use when parsing the markdown content
 * @returns {Promise<Array<MarkdownToken>>} - A promise that resolves to an array of markdown tokens
 */
export const fetchTokens = async function (contentMarkdown, containers) {
  const md = new MarkdownIt();
  // const containers = getContainers(contentMarkdown);

  containers.forEach((id) => md.use(markdownItContainer, id));

  const markdownTokens = md.parse(contentMarkdown, {});
  return markdownTokens;
};

export const escapeAttr = (s = "") =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const getContainerNames = function (file) {
  const lines = file.split("\n");
  const result = lines
    .filter((line) => line.includes(":::") && line.length > 3)
    .map((line) => line.split(":::")[1].trim());
  return result;
};
